<template>
  <div class="wrapper_map">
    <section class="tabs about-page">
      <input id="tab_1" class="tab" type="radio" name="tab" checked="checked">
      <label id="tab_l1" class="tab" for="tab_1" style="margin-left: 250px;">Якиманка</label>
      <div style="clear:both" />
      <div class="tabs_cont">
        <div id="tab_c1">
          <div class="parking">
            <div class="sign">
              P
            </div>
            Бесплатно под шлагбаум
          </div>
          <div id="yandexMapYa" style="width:940px; height:480px" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import maps from '../../assets/mixins/maps'

export default {
  name: 'MapWrapper',
  mixins: [maps]
}
</script>

<style></style>
